// extracted by mini-css-extract-plugin
export default {"authHeader":"t_tse9UXDQZHSA0MFdni","buttons":"U9sxFazIw7GjaFUVYzm7"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"authHeader\":\"t_tse9UXDQZHSA0MFdni\",\"buttons\":\"U9sxFazIw7GjaFUVYzm7\"}";
        // 1791895967603
        var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  